import { createRoot } from 'react-dom/client'
import SiteChrome from './SiteChrome'

for (const node of document.querySelectorAll<HTMLElement>('[data-aelo-site-chrome]')) {
  createRoot(node).render(<SiteChrome homepage={node.dataset.homepage === 'true'} />)
}
